module.exports = __webpack_public_path__ + "img/password.779ff7fa.svg";